import { render, staticRenderFns } from "./masterSingleModel.vue?vue&type=template&id=0cde4bae&scoped=true&"
import script from "./masterSingleModel.vue?vue&type=script&lang=js&"
export * from "./masterSingleModel.vue?vue&type=script&lang=js&"
import style0 from "./masterSingleModel.vue?vue&type=style&index=0&id=0cde4bae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cde4bae",
  null
  
)

export default component.exports